import React from 'react'
import { Pie } from 'react-chartjs-2'
import StyledChart from '../../styled/styled-chart'
import { useSelector } from 'react-redux'


const Chart = () => {

  const characters = useSelector((state) => state.charactersHome.charactersHome)

  const pokemons = characters.filter(character => character.id === undefined )
  const rickAndMorty = characters.filter(character => character.id !== undefined)
  
  const data = {
    labels: ['Pokemon','Rick and Morty'],
    datasets: [
      {
        data: [pokemons.length, rickAndMorty.length],
        backgroundColor: ["#3666ad", "#ad9536"],
        hoverBackgroundColor: ["#1f457d", "#826e21"],

      }
    ]
  }

  return(
    <StyledChart >
      <Pie data={data} />
    </StyledChart>
  )
}

export default Chart